import React from "react";
import MaterialSelect from "../../../../components/MasterSelect";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialInput from "../../../../components/MaterialInput";
import Grid from "@mui/material/Grid2";
import MaterialBox from "../../../../components/MaterialBox";
import { FormControl, FormHelperText } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
function LeaveConfig({
  leaveconfigdata,
  togglePage,
  leaveType,
  handleChange,
  handleleaveconfigdataChange,
  lossofpaydata,
  handleleaveconfig,
}) {
  return (
    <MaterialBox>
      <Grid mt={4} container spacing={2}>
        <Grid size={{lg:4,md:4, xs: 12, sm: 6 }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Leave Type <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
          </MaterialBox>

          <MaterialSelect
            name="leavetype"
            value={leaveconfigdata?.leavetype}
            onChange={handleleaveconfig}
            error={leaveconfigdata.leavetypeStatus === "error"}
            success={leaveconfigdata.leavetypeStatus === "success"}
            isDisabled={togglePage.view === true ? true : false}
            options={leaveType.map((item) => {
              return {
                value: item?.value,
                label: item?.label,
              };
            })}
          />
          {leaveconfigdata.leavetypeStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Type Name is mandatory and should contain text within 25
                characters
              </FormHelperText>
            </FormControl>
          )}
        </Grid>
        <Grid size={{lg:4,md:4, xs: 12, sm: 6 }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Total No Of Days <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            name="numberofdays"
            value={leaveconfigdata.numberofdays}
            onChange={handleleaveconfig}
            error={leaveconfigdata.numberofdaysStatus === "error"}
            success={leaveconfigdata.numberofdaysStatus === "success"}
            disabled={togglePage.view === true ? true : false}
          />
          {leaveconfigdata.numberofdaysStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Should accept only Numbers maximum of two characters{" "}
              </FormHelperText>
            </FormControl>
          )}
        </Grid>
        <Grid size={{lg:4,md:4, xs: 12, sm: 6 }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Apply Before <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            name="applybefore"
            value={leaveconfigdata.applybefore}
            onChange={handleleaveconfig}
            error={leaveconfigdata.applybeforeStatus === "error"}
            success={leaveconfigdata.applybeforeStatus === "success"}
            disabled={togglePage.view === true ? true : false}
          />
          {leaveconfigdata.applybeforeStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Should accept only numbers from 0 to 99.
              </FormHelperText>
            </FormControl>
          )}
        </Grid>
        <Grid size={{lg:3,md:3, xs: 12, sm: 6 }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Apply After <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            name="applyafter"
            value={leaveconfigdata.applyafter}
            onChange={handleleaveconfig}
            error={leaveconfigdata.applyafterStatus === "error"}
            success={leaveconfigdata.applyafterStatus === "success"}
            disabled={togglePage.view === true ? true : false}
          />
          {leaveconfigdata.applyafterStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Should accept only numbers from 0 to 30.
              </FormHelperText>
            </FormControl>
          )}
        </Grid>
        <Grid size={{lg:3,md:3, xs: 12, sm: 4 }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Maximum Consecutive Days <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            name="maximumconsecutivedays"
            onChange={handleleaveconfig}
            value={leaveconfigdata.maximumconsecutivedays}
            error={leaveconfigdata.maximumconsecutivedaysStatus === "error"}
            success={leaveconfigdata.maximumconsecutivedaysStatus === "success"}
            disabled={togglePage.view === true ? true : false}
          />
          {leaveconfigdata.maximumconsecutivedaysStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Should accept only Numbers maximum of two characters
              </FormHelperText>
            </FormControl>
          )}
        </Grid>
        <Grid size={{lg:3,md:3, xs: 12, sm: 4 }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Min Accumulation For Employees{" "}
              <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            name="minaccumulationdays"
            value={leaveconfigdata.minaccumulationdays}
            onChange={handleleaveconfig}
            error={leaveconfigdata.minaccumulationdaysStatus === "error"}
            success={leaveconfigdata.minaccumulationdaysStatus === "success"}
            disabled={togglePage.view === true ? true : false}
          />
          {leaveconfigdata.minaccumulationdaysStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Should not be more than the total number of days or less than
                0.5.
              </FormHelperText>
            </FormControl>
          )}
        </Grid>
        <Grid size={{lg:3,md:3, xs: 12, sm: 4 }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Max Accumulation For Employees{" "}
              <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            name="maxaccumulationdays"
            value={leaveconfigdata.maxaccumulationdays}
            onChange={handleleaveconfig}
            error={leaveconfigdata.maxaccumulationdaysStatus === "error"}
            success={leaveconfigdata.maxaccumulationdaysStatus === "success"}
            disabled={togglePage.view === true ? true : false}
          />
          {leaveconfigdata.maxaccumulationdaysStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Should not be more than the total number of days or less than
                the Min accumulation days.
              </FormHelperText>
            </FormControl>
          )}
        </Grid>

        <Grid size={{lg:4,md:4, xs: 12, sm: 6 }} sx={{textAlign:'center'}}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Eligible Intern
            </MaterialTypography>
          </MaterialBox>
          <FormControlLabel
            control={
              <Switch
                checked={leaveconfigdata.eligibleIntern}
                onChange={(e) =>
                  handleleaveconfigdataChange({
                    target: {
                      name: "eligibleIntern",
                      value: e.target.checked,
                    },
                  })
                }
                color="primary"
              />
            }
            label={leaveconfigdata.eligibleIntern ? "Yes" : "No"}
            disabled={togglePage.view === true ? true : false}
          />
        </Grid>
        <Grid size={{lg:4,md:4, xs: 12, sm: 6 }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Min Accumulation For Interns
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            name="minaccumalationforintern"
            value={leaveconfigdata.minaccumalationforintern}
            onChange={handleleaveconfig}
            error={leaveconfigdata.minaccumalationforinternStatus === "error"}
            success={
              leaveconfigdata.minaccumalationforinternStatus === "success"
            }
            disabled={
              !leaveconfigdata.eligibleIntern || togglePage.view === true
            }
          />
          {leaveconfigdata.minaccumalationforinternStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Should not be more than the total number of days or less than
                0.5.
              </FormHelperText>
            </FormControl>
          )}
        </Grid>
        <Grid size={{lg:4,md:4, xs: 12, sm: 6 }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Max Accumulation For Interns
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            name="maxaccumalationforintern"
            value={leaveconfigdata.maxaccumalationforintern}
            onChange={handleleaveconfig}
            error={leaveconfigdata.maxaccumalationforinternStatus === "error"}
            success={
              leaveconfigdata.maxaccumalationforinternStatus === "success"
            }
            disabled={
              !leaveconfigdata.eligibleIntern || togglePage.view === true
            }
          />
          {leaveconfigdata.maxaccumalationforinternStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Should not be more than the total number of days or less than
                the Min accumulation for interns.
              </FormHelperText>
            </FormControl>
          )}
        </Grid>
        <Grid size={{lg:4,md:4, xs: 12, sm: 6 }} sx={{textAlign:'center'}}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Eligible Probation
            </MaterialTypography>
          </MaterialBox>
          <FormControlLabel
            sx={{ marginLeft: "1%" }}
            control={
              <Switch
                checked={leaveconfigdata.eligibleprobation}
                onChange={(e) =>
                  handleleaveconfigdataChange({
                    target: {
                      name: "eligibleprobation",
                      value: e.target.checked,
                    },
                  })
                }
                color="primary"
              />
            }
            label={leaveconfigdata.eligibleprobation ? "Yes" : "No"}
            disabled={togglePage.view === true ? true : false}
          />
        </Grid>
        <Grid size={{lg:4,md:4, xs: 12, sm: 6 }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Min Accumulation For Probation Employees
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            name="minaccumalationforproemp"
            value={leaveconfigdata.minaccumalationforproemp}
            onChange={handleleaveconfig}
            error={leaveconfigdata.minaccumalationforproempStatus === "error"}
            success={
              leaveconfigdata.minaccumalationforproempStatus === "success"
            }
            disabled={
              !leaveconfigdata.eligibleprobation || togglePage.view === true
            }
          />
          {leaveconfigdata.minaccumalationforproempStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Should not be more than the total number of days or less than
                0.5.
              </FormHelperText>
            </FormControl>
          )}
        </Grid>
        <Grid size={{lg:4,md:4, xs: 12, sm: 6 }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Max Accumulation For Probation Employees
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            name="maxaccumalationforproemp"
            value={leaveconfigdata.maxaccumalationforproemp}
            onChange={handleleaveconfig}
            error={leaveconfigdata.maxaccumalationforproempStatus === "error"}
            success={
              leaveconfigdata.maxaccumalationforproempStatus === "success"
            }
            disabled={
              !leaveconfigdata.eligibleprobation || togglePage.view === true
            }
          />
          {leaveconfigdata.maxaccumalationforproempStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Should not be more than the total number of days or less than
                the Min accumulation for probation employees.
              </FormHelperText>
            </FormControl>
          )}
        </Grid>

        <Grid sx={{ paddingLeft: 13, paddingRight: 15 }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              IS Leave WithoutPay
            </MaterialTypography>
          </MaterialBox>
          <FormControlLabel
            sx={{ marginLeft: "1%" }}
            control={
              <Switch
                checked={leaveconfigdata.leavewithoutpay}
                onChange={(e) =>
                  handleleaveconfigdataChange({
                    target: {
                      name: "leavewithoutpay",
                      value: e.target.checked,
                    },
                  })
                }
                color="primary"
              />
            }
            label={leaveconfigdata.leavewithoutpay ? "Yes" : "No"}
            disabled={leaveconfigdata.leavetype?.value !== "Loss Of Pay"}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              LOP From
            </MaterialTypography>
          </MaterialBox>

          <MaterialSelect
            name="lopfrom"
            value={leaveconfigdata?.lopfrom}
            onChange={handleleaveconfig}
            error={leaveconfigdata.lopfromStatus === "error"}
            success={leaveconfigdata.lopfromStatus === "success"}
            // isDisabled={togglePage.view === true ? true : false}
            isDisabled={
              !leaveconfigdata.leavewithoutpay || togglePage.view === true
            }
            options={lossofpaydata.map((item) => {
              return {
                value: item?.value,
                label: item?.label,
              };
            })}
          />
          {leaveconfigdata.lopfromStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Type Name is mandatory and should contain text within 25
                characters
              </FormHelperText>
            </FormControl>
          )}
        </Grid>

        <Grid sx={{ paddingLeft: 13, paddingRight: 19 }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Allow Negative
            </MaterialTypography>
          </MaterialBox>
          <FormControlLabel
            sx={{ marginLeft: "1%" }}
            control={
              <Switch
                checked={leaveconfigdata.allownegative}
                onChange={(e) =>
                  handleleaveconfigdataChange({
                    target: {
                      name: "allownegative",
                      value: e.target.checked,
                    },
                  })
                }
                color="primary"
              />
            }
            label={leaveconfigdata.allownegative ? "Yes" : "No"}
            disabled={togglePage.view === true ? true : false}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Maximum Negative Days
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            name="maximumnegativedays"
            value={leaveconfigdata.maximumnegativedays}
            onChange={handleChange}
            error={leaveconfigdata.maximumnegativedaysStatus === "error"}
            success={leaveconfigdata.maximumnegativedaysStatus === "success"}
            disabled={
              !leaveconfigdata.allownegative || togglePage.view === true
            }
          />
          {leaveconfigdata.maximumnegativedaysStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Should accept only Numbers maximum of two characters{" "}
              </FormHelperText>
            </FormControl>
          )}
        </Grid>

        <Grid ml={13}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Based on Pro Rata Basis
            </MaterialTypography>
          </MaterialBox>
          <FormControlLabel
            sx={{ marginLeft: "1%" }}
            control={
              <Switch
                checked={leaveconfigdata.basedonpro}
                onChange={(e) =>
                  handleleaveconfigdataChange({
                    target: {
                      name: "basedonpro",
                      value: e.target.checked,
                    },
                  })
                }
                color="primary"
              />
            }
            label={leaveconfigdata.basedonpro ? "Yes" : "No"}
            disabled={togglePage.view === true ? true : false}
          />
        </Grid>
        <Grid ml={23}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Attachment Mandatory
            </MaterialTypography>
          </MaterialBox>
          <FormControlLabel
            sx={{ marginLeft: "1%" }}
            control={
              <Switch
                checked={leaveconfigdata.Attachmentdoc}
                onChange={(e) =>
                  handleleaveconfigdataChange({
                    target: {
                      name: "Attachmentdoc",
                      value: e.target.checked,
                    },
                  })
                }
                color="primary"
              />
            }
            label={leaveconfigdata.Attachmentdoc ? "Yes" : "No"}
            disabled={togglePage.view === true ? true : false}
          />
        </Grid>
        <Grid ml={30}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Active
            </MaterialTypography>
          </MaterialBox>
          <FormControlLabel
            // sx={{ marginLeft: "1%" }}
            control={
              <Switch
                checked={leaveconfigdata.active}
                onChange={(e) =>
                  handleleaveconfigdataChange({
                    target: {
                      name: "active",
                      value: e.target.checked,
                    },
                  })
                }
                color="primary"
              />
            }
            label={leaveconfigdata.active ? "Yes" : "No"}
            disabled={togglePage.view === true ? true : false}
          />
        </Grid>
      </Grid>
    </MaterialBox>
  );
}

export default LeaveConfig;
